import type { DestinationFormValue } from '@/shared/api/types/destination-types'

/** Starting values of the destination form (also the baseline for "is the draft empty"). */
export const DEFAULT_DESTINATION_FORM: DestinationFormValue = {
  countryId: '',
  provinceId: '',
  slug: '',
  destinationType: '',
  areaBoundary: null,
  centerPoint: null,
  banner: '',
  thumbnail: '',
  isActive: true,
}

/** Entity id the create form files its draft and translation jobs under (destinations are global, not per tenant). */
export const DESTINATION_DRAFT_ENTITY_ID = 'draft:destination:global'
